import apiClient from '../utils/apiClient';

export const getFCDataByDeviceName = async deviceName => {
  try {
    const response = await apiClient.get(
      `/values/Measurement?name=${deviceName}`,
      {
        headers: {
          'Cache-Control': 'no-cache',
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
};
